import { Container, Card } from "react-bootstrap";

const ContactUser = () => (
  <Container className="mt-4">
    <div className="p-4 shadow">
      <h4>Kontak BPS Provinsi Bali</h4>
      <p>Email: pst5100@bps.go.id</p>
      <p>Telepon: (0361) 238159</p>
    </div>
  </Container>
);

export default ContactUser;
